import styled from '@emotion/styled';
import { Text } from '~/shared/components/Text';
import { breakpoints, queriesIsolated } from '~/theme';
import { ifProp } from 'styled-tools';

export const StyledNavigation = styled.nav({
    display: 'flex',
});

export const StyledBreadcrumbContainer = styled.ol({
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
});

export const StyledBreadcrumb = styled.li(({ theme }) => ({
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: theme.colors.dark,
    [breakpoints.md]: {
        color: theme.colors.dark50,
    },
    '&[aria-current]': {
        color: theme.colors.dark50,
    },
    [`${Text}`]: {
        color: 'inherit',
    },
    // Hide the "Home" item on small resolutions
    '&:first-of-type': {
        display: 'none',
        [breakpoints.sm]: {
            display: 'block',
        },
    },
    '& + &': {
        position: 'relative',

        '&:before': {
            content: '"/"',
            display: 'inline-block',
            padding: `0 ${theme.spaces[1]}`,
            color: 'inherit',
            fontSize: theme.fontSizes.xs,
            lineHeight: 1,
        },

        '&:nth-of-type(-n+2):before': {
            [`@media ${queriesIsolated.xs}`]: {
                content: 'none',
            },
        },
    },
}));

export const StyledBreadcrumbText = styled(Text)<{ isLast?: boolean }>(
    ifProp('isLast', ({ theme }) => ({
        fontWeight: theme.fontWeights.bold,
    }))
);
